import { MenuItem } from './menu.model';

/**
 * Affichage sidebar : même condition pour « Mes factures » et le hub facturation (menu renommé ex. « Pennylane gestion »).
 * Masqué si aucune activation Pennylane Gestion pour la firme (voir `sidebar.component`).
 */
export const PENNYLANE_GESTION_MENU_APPLICATION = 'PENNYLANE_GESTION';

export const MENU: MenuItem[] = [
  {
    id: 1,
    label: 'menuItems.menu.title',
    isTitle: true,
  },
  {
    id: 2,
    label: 'menuItems.dashboards.title',
    icon: 'home',
    link: '/',
  },
  {
    id: 3,
    label: 'menuItems.myFolder.title',
    icon: 'folder',
    link: '/my-folders',
    roles: [
      'COMPANY_VIEW',
      'COMPANY_VIEW_ALL',
      'COMPANY_CREATE',
      'COMPANY_EDIT',
      'COMPANY_DELETE',
    ],
  },
  {
    id: 28,
    label: 'menuItems.myContacts.title',
    icon: 'users',
    link: '/my-contacts',
    roles: [
      'COMPANY_VIEW',
      'COMPANY_VIEW_ALL',
      'COMPANY_CREATE',
      'COMPANY_EDIT',
      'COMPANY_DELETE',
    ],
  },
  {
    id: 100,
    label: 'menuItems.deadline.title',
    icon: 'Clock',
    link: '/deadlines',
    roles: [
      'TASK_VIEW',
      'TASK_VIEW_ALL',
      'TASK_CREATE',
      'TASK_EDIT',
      'TASK_DELETE',
    ],
  },
  {
    id: 21,
    label: 'menuItems.monitoringDeadline.title',
    icon: 'Activity',
    link: '/monitoring-deadlines',
    roles: [
      'TASK_VIEW',
      'TASK_VIEW_ALL',
      'TASK_CREATE',
      'TASK_EDIT',
      'TASK_DELETE',
    ],
  },
  {
    id: 19,
    label: 'menuItems.planning.title',
    icon: 'Calendar',
    link: '/planning',
    roles: [
      'TASK_VIEW',
      'TASK_VIEW_ALL',
      'TASK_CREATE',
      'TASK_EDIT',
      'TASK_DELETE',
    ],
  },
  {
    id: 20,
    label: 'menuItems.taskTracking.title',
    icon: 'List',
    link: '/monitoring-tasks',
    roles: [
      'TASK_VIEW',
      'TASK_VIEW_ALL',
      'TASK_CREATE',
      'TASK_EDIT',
      'TASK_DELETE',
    ],
  },
  {
    id: 22,
    label: 'menuItems.Tasks.title',
    icon: 'clipboard',
    link: '/my-tasks',
    roles: [
      'TASK_VIEW',
      'TASK_VIEW_ALL',
      'TASK_CREATE',
      'TASK_EDIT',
      'TASK_DELETE',
    ],
  },
  /*
  {
    id: 13,
    label: 'menuItems.myInvoices.title',
    icon: 'file-text',
    link: '/my-invoices',
    application: PENNYLANE_GESTION_MENU_APPLICATION,
  },*/
  {
    id: 14,
    label: 'menuItems.massProcessing.title',
    icon: 'Zap',
    link: '/mass-processing',
    roles: [
      'COMPANY_VIEW',
      'COMPANY_VIEW_ALL',
      'COMPANY_CREATE',
      'COMPANY_EDIT',
      'COMPANY_DELETE',
    ],
  },
  {
    id: 15,
    label: 'menuItems.impots_gouv.title',
    icon: 'Monitor',
    link: '/impots_gouv/messagerie',
    application: 'IMPOTS_GOUV',
    roles: [
      'COMPANY_VIEW',
      'COMPANY_VIEW_ALL',
      'COMPANY_CREATE',
      'COMPANY_EDIT',
      'COMPANY_DELETE',
    ],
  },
  {
    id: 129,
    label: 'menuItems.billingCenter.title',
    icon: 'credit-card',
    link: '/billing-center',
    application: PENNYLANE_GESTION_MENU_APPLICATION,
  },
  {
    id: 4,
    label: 'menuItems.commercial.title',
    icon: 'Briefcase',
    roles: [
      'CONTRACT_VIEW',
      'CONTRACT_VIEW_ALL',
      'CONTRACT_CREATE',
      'CONTRACT_EDIT',
      'CONTRACT_DELETE',
    ],
    subItems: [
      {
        id: 5,
        label: 'menuItems.commercial.list.opportunity',
        link: '/commercial/opportunity',
        parentId: 4,
        roles: [
          'CONTRACT_VIEW',
          'CONTRACT_VIEW_ALL',
          'CONTRACT_CREATE',
          'CONTRACT_EDIT',
          'CONTRACT_DELETE',
        ],
      },
    ],
  },
  {
    id: 6,
    label: 'menuItems.setting.title',
    icon: 'settings',
    subItems: [
      {
        id: 7,
        label: 'menuItems.setting.list.firm',
        link: '/settings/firm/firm-info',
        parentId: 6,
        profileCode: 'PROFILE_CPA',
        roles: [
          'FIRM_VIEW',
          'FIRM_VIEW_ALL',
          'FIRM_CREATE',
          'FIRM_EDIT',
          'FIRM_DELETE',
        ],
      },
      {
        id: 8,
        label: 'menuItems.setting.list.users',
        link: '/settings/users',
        parentId: 6,
        roles: [
          'USERFIRM_VIEW',
          'USERFIRM_VIEW_ALL',
          'USERFIRM_CREATE',
          'USERFIRM_EDIT',
          'USERFIRM_DELETE',
        ],
      },
      {
        id: 9,
        label: 'menuItems.setting.list.teams',
        link: '/settings/teams',
        parentId: 6,
        roles: [
          'TEAM_VIEW',
          'TEAM_VIEW_ALL',
          'TEAM_CREATE',
          'TEAM_EDIT',
          'TEAM_DELETE',
        ],
      },
      {
        id: 10,
        label: 'menuItems.setting.list.folders',
        link: '/settings/folders/manage-tax',
        parentId: 6,
        roles: [
          'TAX_VIEW',
          'TAX_VIEW_ALL',
          'TAX_CREATE',
          'TAX_EDIT',
          'TAX_DELETE',
          'CATEGORY_VIEW',
          'CATEGORY_VIEW_ALL',
          'CATEGORY_CREATE',
          'CATEGORY_EDIT',
          'CATEGORY_DELETE',
          'LEGALFORM_VIEW',
          'LEGALFORM_VIEW_ALL',
          'LEGALFORM_CREATE',
          'LEGALFORM_EDIT',
          'LEGALFORM_DELETE',
          'CHANNEL_VIEW',
          'CHANNEL_VIEW_ALL',
          'CHANNEL_CREATE',
          'CHANNEL_EDIT',
          'CHANNEL_DELETE',
          'COMPANYROLE_VIEW',
          'COMPANYROLE_VIEW_ALL',
          'COMPANYROLE_CREATE',
          'COMPANYROLE_EDIT',
          'COMPANYROLE_DELETE',
          'COMPANYSTATUS_VIEW',
          'COMPANYSTATUS_VIEW_ALL',
          'COMPANYSTATUS_CREATE',
          'COMPANYSTATUS_EDIT',
          'COMPANYSTATUS_DELETE',
          'PRODUCT_VIEW',
          'PRODUCT_VIEW_ALL',
          'PRODUCT_CREATE',
          'PRODUCT_EDIT',
          'PRODUCT_DELETE',
          'ACTIVITY_VIEW',
          'ACTIVITY_VIEW_ALL',
          'ACTIVITY_CREATE',
          'ACTIVITY_EDIT',
          'ACTIVITY_DELETE',
        ],
      },
      {
        id: 11,
        label: 'API publique',
        link: '/settings/public-api',
        parentId: 6,
        roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN', 'ROLE_CPA', 'PROFILE_CPA'],
      },
      {
        id: 12,
        label: 'menuItems.setting.list.variable',
        link: '/settings/variables',
        parentId: 6,
      },
      {
        id: 13,
        label: 'menuItems.setting.list.applications',
        link: '/settings/applications',
        parentId: 6,
        roles: [
          'PROVIDER_VIEW',
          'PROVIDER_VIEW_ALL',
          'PROVIDER_CREATE',
          'PROVIDER_EDIT',
          'PROVIDER_DELETE',
        ],
      },
      {
        id: 17,
        label: 'menuItems.setting.list.missionLetter',
        link: '/settings/ldm-model',
        parentId: 6,
        roles: [
          'CONTRACTMODEL_VIEW',
          'CONTRACTMODEL_VIEW_ALL',
          'CONTRACTMODEL_CREATE',
          'CONTRACTMODEL_EDIT',
          'CONTRACTMODEL_DELETE',
        ],
      },
      {
        id: 18,
        label: 'menuItems.setting.list.fileAssignment',
        link: 'settings/file-assignment',
        parentId: 6,
        roles: [
          'COMPANYUSERROLE_VIEW',
          'COMPANYUSERROLE_VIEW_ALL',
          'COMPANYUSERROLE_CREATE',
          'COMPANYUSERROLE_EDIT',
          'COMPANYUSERROLE_DELETE',
        ],
      },
      {
        id: 15,
        label: 'menuItems.setting.list.tasks',
        link: 'settings/tasks',
        parentId: 6,
        roles: [
          'TASK_VIEW',
          'TASK_VIEW_ALL',
          'TASK_CREATE',
          'TASK_EDIT',
          'TASK_DELETE',
        ],
      },
    ],
  },
];
